import { useEffect, useState } from 'react';

import {
  AssignmentConfirmationJobGQLType,
  useGetRepurchaseAndTransferJobsQuery,
} from 'types/dashboard-core-gqlTypes.generated.d';

export const usePollRepurchaseAndTransferJobs = ({
  implementationId,
}: {
  implementationId: string;
}) => {
  const [repurchaseAndTransferJobs, setRepurchaseAndTransferJobs] = useState<
    AssignmentConfirmationJobGQLType[]
  >([]);

  const {
    data,
    startPolling,
    stopPolling,
  } = useGetRepurchaseAndTransferJobsQuery({
    fetchPolicy: 'no-cache',
    variables: {
      implementationId,
    },
  });

  useEffect(() => {
    startPolling(5000);
    return () => {
      stopPolling();
    };
  }, [startPolling, stopPolling]);

  useEffect(() => {
    setRepurchaseAndTransferJobs(data?.repurchaseAndTransferJobs ?? []);
  }, [data]);

  return {
    repurchaseAndTransferJobs,
  };
};
